// ./src/contexts/PointsOfInterestContext/PointsOfInterestContext.tsx
//
// Thin context wrapper around the usePointsOfInterest hook. All derived data
// lives in the hook itself. See HighlightsContext for the pattern.

import React, { createContext, useContext } from "react";

import {
  usePointsOfInterest,
  UsePointsOfInterestOptions,
  UsePointsOfInterestReturn,
} from "@/hooks/usePointsOfInterest";

const PointsOfInterestContext = createContext<UsePointsOfInterestReturn | null>(null);

export interface PointsOfInterestProviderProps extends UsePointsOfInterestOptions {
  children: React.ReactNode;
}

export const PointsOfInterestProvider: React.FC<PointsOfInterestProviderProps> = ({ children, ...options }) => {
  const value = usePointsOfInterest(options);

  return <PointsOfInterestContext.Provider value={value}>{children}</PointsOfInterestContext.Provider>;
};

export const usePointsOfInterestContext = (): UsePointsOfInterestReturn => {
  const context = useContext(PointsOfInterestContext);

  if (!context) {
    throw new Error(
      "usePointsOfInterestContext must be used within a <PointsOfInterestProvider>. " +
        "Wrap your component tree with <PointsOfInterestProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalPointsOfInterestContext = (): UsePointsOfInterestReturn | null => {
  return useContext(PointsOfInterestContext);
};
